<template>
    <div class="idea">
        <div class="bg">
            <div class="section-content">
                <div style="padding-top: 64px;">
                    Teaching philosophy of SHICHIDA
                    <p>七田真理念</p>
                </div>
            </div>
        </div>
         <div class="section-content">
             <div class="content">
                 <img src="../../assets/imgs/brand/qty-read.png" style="width: 260px;margin-top: 100px;"/>
                 <div class="list">
                     <div>每个孩子都是天才</div>
                     <div>教育越早越好</div>
                     <div>以爱心为基础, 通过感动培养才能</div>
                     <div style="margin-top:-22px;">基础认知能力培养是早期教育的必修课</div>
                 </div>
             </div>
         </div>

    </div>
</template>
<script>
    export default {
        data(){
            return{

            }
        },
    }
</script>
<style lang="less" scoped>
    .idea{
        .bg{
            width: 100%;
            height: 300px;
            background: url("../../assets/imgs/bg-bottom.png") repeat-x;
            font-size: 30px;
            color: #ffffff;
            font-weight:600;
        }
        .content{
            width: 900px;
            margin: 0px auto 120px;
            height: 460px;
            background: url('../../assets/imgs/brand/idea-bg.png') no-repeat;
            background-position: 100% 0%;
            background-size: 44% 100%;
            .list{
                width: 350px;
                height: 460px;
                float: right;
                div{
                    color: #5e5e5e;
                    font-size: 16px;
                    font-weight: normal;
                    width: 150px;
                    margin-top: 50px;
                    margin-bottom: 90px;
                }
            }
        }



    }
</style>

